import type { TranslationSchema } from '../zh';

const common: TranslationSchema['common'] = {
  home: 'Trang chủ',
  add: 'Thêm mới',
  edit: 'Chỉnh sửa',
  delete: 'Xóa',
  detail: 'Chi tiết',
  search: 'Tìm kiếm',
  reset: 'Đặt lại',
  confirm: 'Xác nhận',
  cancel: 'Hủy',
  close: 'Đóng',
  save: 'Lưu',
  logout: 'Đăng xuất',
  enabled: 'Bật',
  disabled: 'Tắt',
  yes: 'Có',
  no: 'Không',
  network_error: 'Lỗi mạng, vui lòng thử lại sau',
  language: 'Ngôn ngữ'
};

export default common;
